import axios from '@/axios';

// URL and endpoint constants
const INDEX_URL = '/our_scientists/1';

export default {
  index(succ) {
    axios.get(INDEX_URL)
      .then((response) => { succ(response); });
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/askScientis.js